module.exports = __webpack_public_path__ + "img/research_7.80552073.png";